import { useEffect, useState } from "react";

import styled from "styled-components/macro";

import { AnimatePresence, motion } from "motion/react";

export default function FnrToggleSwitch({
  onToggle,
  loading,
  defaultOn,
  includeCheckmark = true,
  color,
  labels,
}) {
  const [on, setOn] = useState(defaultOn);
  const [loadingTriggered, setLoadingTriggered] = useState(false);
  const [showSavedIcon, setShowSavedIcon] = useState(false);

  useEffect(() => {
    if (loading && !loadingTriggered) setLoadingTriggered(true);
    if (!loading && loadingTriggered) {
      if (includeCheckmark) setShowSavedIcon(true);
      setLoadingTriggered(false);
      if (includeCheckmark) setTimeout(() => setShowSavedIcon(false), 1500);
    }
  }, [loading, loadingTriggered, includeCheckmark]);

  const handleClick = (e) => {
    if (showSavedIcon || loading) return;
    if (includeCheckmark) setShowSavedIcon(false);
    setOn(!on);
    onToggle(!on, e);
  };

  const hasLabels = labels?.on && labels?.off;

  return (
    <Wrapper
      $color={color}
      $on={on}
      $hasLabels={hasLabels}
      onClick={handleClick}
    >
      <Switch $on={on} $hasLabels={hasLabels}>
        <AnimatePresence>
          {loading && (
            <LoadingIcon
              initial={{ opacity: 0.75 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              // transition={{ delay: 0.25 }}
              className="far fa-circle-notch"
            />
          )}
        </AnimatePresence>
        <AnimatePresence>
          {includeCheckmark && showSavedIcon && (
            <SavedIcon
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ delay: 0.25 }}
              className="fas fa-check"
            />
          )}
        </AnimatePresence>
      </Switch>
      {hasLabels && <Label $on={on}>{on ? labels.on : labels.off}</Label>}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  border-radius: 36px;
  box-sizing: border-box;
  height: 24px;
  width: ${({ $hasLabels }) => ($hasLabels ? "49" : "36")}px;
  background: #bec3c7;
  border: 1px solid #98a4a5;
  box-shadow: inset rgba(0, 0, 0, 0.25) 0 0 4px;
  cursor: pointer;
  position: relative;
  transition: 0.25s;

  ${({ $on, $color }) =>
    $on &&
    `
       background: ${$color || "#24CE7B"};
    `}
`;

const Switch = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -10px;
  margin-top: -10px;
  transform: translateX(-${({ $hasLabels }) => ($hasLabels ? "12" : "6")}px);
  transition: 0.25s;

  ${({ $on, $hasLabels }) =>
    $on &&
    `
      transform: translateX(${$hasLabels ? "12" : "6"}px);
    `}
`;

const Label = styled.div`
  color: #fff;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 3px;

  width: 100%;
  box-sizing: border-box;
  font-weight: 400;

  ${({ $on }) => !$on && `justify-content: flex-end;`}
`;

const IndicatorIcon = styled(motion.div)`
  /* display: none; */
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  color: #98a4a5;
  /* opacity: 0;
  visibility: hidden; */
  transform: scale(0.5);
  transition: 0.2s;
`;

const LoadingIcon = styled(IndicatorIcon)`
  /* ${({ loading }) => loading && `display: block;`} */
  /* display: ${({ loading }) => (loading ? "block" : "none")}; */
  animation: fa-spin 2s infinite linear;
`;

const SavedIcon = styled(IndicatorIcon)`
  /* ${({ show }) => show && `display: block;`} */
  /* display: ${({ show }) => (show ? "block" : "none")}; */
  font-size: 22px;
  font-weight: 900;
`;
